import * as React from "react";
import { useFieldProps } from "src/hooks/form/useField";
import useCarriers from 'src/hooks/fields/useCarriers';

const useShippingLines = <T>(
  props: useFieldProps<T>,
) => {
	/** Using only for Shipping Lines */
	const shippingLines = useCarriers(props, 'SL');
	return shippingLines;
	
};

export default useShippingLines;
